// Centralized brand constants
// Logo served same-origin from the React app's public/ folder. We used to
// reference customer-assets.emergentagent.com directly, but desktop Chrome
// occasionally failed to fetch it (no fallback → broken-image glyph in the
// sidebar/login/etc.). Self-hosting eliminates the CDN dependency.
export const LOGO_URL = "/gcoms-logo.png";
export const BRAND = "GCOMS.RN";
export const AI_MODULE_NAME = "GCOMS.ai";
export const PRACTICE = "Gold Coast Oral & Maxillofacial Surgery";
export const PRACTICE_EMAIL = "info@goldcoastoms.com";
export const PRACTICE_ADDRESS = "55 Bryant Ave, Suite 200, Roslyn, NY 11576";
export const PRACTICE_PHONE = "516-744-6262";
export const BRAND_ORANGE = "#F26A24";

export const EVAL_OPTIONS = [
  "Extractions",
  "Orthognathic Surgery",
  "Maxillofacial Pathology",
  "Surgical TMJ Evaluation",
  "Dental Implants",
];

// Universal numbering: 1–32 (permanent) + A–T (primary)
export const TEETH_UPPER = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16];
export const TEETH_LOWER = [32,31,30,29,28,27,26,25,24,23,22,21,20,19,18,17];
export const PRIMARY_UPPER = ["A","B","C","D","E","F","G","H","I","J"];
export const PRIMARY_LOWER = ["T","S","R","Q","P","O","N","M","L","K"];
